module.exports = __webpack_public_path__ + "a6b682f818595f5de939ee1b233b4fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2083_teaser_image.jpg
// module id = 589
// module chunks = 0